import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagProducaoResponse } from '../../responses/suprimentos/get-tag-producao.response';
import { CriarTagProducaoResponse } from '../../responses/suprimentos/criar-tag-producao.response';
import { TagSuprimentosRequest } from '../../requests/suprimentos/tag-suprimentos.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagProducaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiSuprimentos + 'TagProducao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagProducaoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagProducaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CriarTagProducaoResponse> {
        const url = `${this.apiUrl}/idTagProducao/${id}`;
        return this.httpClient
            .get<CriarTagProducaoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagSuprimentosRequest): Observable<CriarTagProducaoResponse> {
        return this.httpClient
            .post<CriarTagProducaoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagSuprimentosRequest): Observable<CriarTagProducaoResponse> {
        const url = `${this.apiUrl}/idTagProducao/${id}`;
        return this.httpClient
            .put<CriarTagProducaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagProducao/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
